import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main_div" }
const _hoisted_2 = { style: {"height":"auto"} }
const _hoisted_3 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_4 = {
  key: 1,
  class: "error-message"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "table-container" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_9 = { style: {"margin":"0 10px"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "error-message",
  style: {"margin-top":"10px"}
}
const _hoisted_12 = {
  key: 2,
  style: {"margin-top":"10px","text-align":"center"}
}
const _hoisted_13 = {
  key: 3,
  class: "pagination-controls",
  style: {"margin-top":"15px","text-align":"center"}
}
const _hoisted_14 = { style: {"margin":"0 10px"} }
const _hoisted_15 = {
  key: 1,
  style: {"margin-top":"20px","text-align":"center","color":"#777"}
}
const _hoisted_16 = {
  key: 0,
  class: "order-details-content"
}
const _hoisted_17 = { style: {"text-align":"right","margin-top":"20px"} }

import { ref, onMounted, h, computed, VNode } from "vue";
import {
  NSpace,
  NCard,
  NButton,
  NDataTable,
  NModal,
  NSelect,
  NDescriptions,
  NDescriptionsItem,
  useMessage,
  useNotification,
  NTabs,
  NTabPane,
  NFormItem,
  NDatePicker,
  useDialog,
  NSpin,
  NInputGroup,
  NInput,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { useRouter } from "vue-router";
import { getCallable } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { useAuth } from "@/composables/useAuth";
import { ChangeStatus } from "@/model/base";
import { Order, OrderItem } from "@/model/order"; // OrderItem 추가
import { useOrderApi } from "@/composables/useOrderForm";
import { USER_ROUTES } from "@/assets/route_constants";
import { usePagination } from "@/composables/usePagination"; // usePagination 임포트
import { useActionDialog } from "@/composables/useDialog";
import { useDownload } from "@/composables/useDownload";
import { getQuotationStatusString } from "@/composables/useOrderForm";

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderQuotation',
  setup(__props) {

const { downloadQuotationFile } = useDownload();
const { show: showActionDialog } = useActionDialog();
const { deleteOrder } = useOrderApi();

const { loading } = useAuth(); // 전역 로딩 상태
const router = useRouter();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const TAB = {
  PENDING_REQUESTS: "pending",
  ACCEPTED_LIST: "accepted",
};
const currentTab = ref(TAB.PENDING_REQUESTS);
const dateRangeForAccepted = ref<[number, number] | null>(null);
const showAcceptedResults = ref(false);

const showOrderDetailsModal = ref(false);
const selectedOrder = ref<Order | null>(null);

const searchValueForPending = ref<string | null>(null);
const searchTypeForPending = ref("client.name");
const searchValueForAccepted = ref<string | null>(null);
const searchTypeForAccepted = ref("client.name");

const getOrgQuotationRequestCallable = getCallable("getOrgQuotationRequest");
const getOrgQuotationApprovedCallable = getCallable("getOrgQuotationApproved");
const orgQuotationToOrderCallable = getCallable("orgQuotationToOrder"); // 견적 확정 함수
const cancelQuotationCallable = getCallable("cancelQuotation"); // 견적 취소 함수

const searchOptions = [
  { label: "기관명", value: "client.name" },
  { label: "담당자", value: "client.deptPersonName" },
];

const isSearchEnabled = computed(() => {
  return (
    dateRangeForAccepted.value !== null || (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "")
  );
});

const activeColumns = computed(() => {
  const baseColumns = [
    { title: "기관명", key: "client.name", resizable: true },
    { title: "담당부서", key: "client.dept", resizable: true, render: (row: Order) => row.client.dept || "N/A" },
    {
      title: "담당자",
      key: "client.deptPersonName",
      resizable: true,
      render: (row: Order) => row.client.deptPersonName || "N/A",
    },
    {
      title: "총 금액", // 견적 요청 단계에서는 없을 수 있음
      key: "totalPrice",
      resizable: true,
      render: (row: Order) => (row.totalPrice ? `${row.totalPrice.toLocaleString()}원` : "N/A"),
    },
    {
      title: "상태",
      key: "status",
      resizable: true,
      render: (row: Order) => getQuotationStatusString(row.status),
    },
    {
      title: currentTab.value === TAB.PENDING_REQUESTS ? "요청일" : "수락일",
      key: "createdDate",
      resizable: true,
      render: (row: Order) => {
        if (currentTab.value === TAB.PENDING_REQUESTS) {
          const timestamp = Number(row.createdDate);
          return !isNaN(timestamp) ? common.getYYYYMMDD2(new Date(timestamp)) : row.createdDate || "N/A";
        } else {
          const timestamp = Number(row.lastUpdatedDate);
          return !isNaN(timestamp) ? common.getYYYYMMDD2(new Date(timestamp)) : row.lastUpdatedDate || "N/A";
        }
      },
    },
  ];

  if (currentTab.value === TAB.PENDING_REQUESTS) {
    return [
      ...baseColumns,
      {
        title: "작업",
        key: "actions",
        render(row: Order) {
          const actionButtons: VNode[] = [
            h(
              NButton,
              { strong: true, tertiary: true, size: "small", onClick: () => displayOrderDetails(row) },
              { default: () => "상세" }
            ),
            h(
              NButton,
              {
                style: "margin-left: 6px",
                strong: true,
                tertiary: true,
                size: "small",
                onClick: () => approveQuotation(row.SK),
                disabled: row.status !== constant.orderStatus.PENDING,
              },
              { default: () => "수락" }
            ),
            h(
              NButton,
              {
                style: "margin-left: 6px",
                strong: true,
                tertiary: true,
                size: "small",
                type: "error",
                onClick: () => cancelQuotation(row.SK),
                disabled: row.status !== constant.orderStatus.PENDING,
              },
              { default: () => "거절" }
            ),
          ];
          return actionButtons;
        },
      },
    ];
  } else {
    // TAB.ACCEPTED_LIST
    return [
      ...baseColumns,
      // { title: "수락일", key: "acceptedDate", /* ... */ }, // 수락일 정보가 있다면 추가
      {
        title: "작업",
        key: "actions",
        render(row: Order) {
          return h(
            NButton,
            { strong: true, tertiary: true, size: "small", onClick: () => displayOrderDetails(row) },
            { default: () => "상세" }
          );
        },
      },
    ];
  }
});

const orderItemColumns = [
  { title: "상품명", key: "name", resizable: true },
  {
    title: "단가",
    key: "unit_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.unit_price || 0).toLocaleString()}원`,
  },
  { title: "수량", key: "quantity", resizable: true },
  {
    title: "공급가액",
    key: "supply_price",
    resizable: true,
    render: (row: OrderItem) => `${Number(row.supply_price || 0).toLocaleString()}원`,
  },
];

const getQuotations = async (params: any) => {
  const queryParams: any = { ...params }; // pageInfo 등 기본 파라미터 복사

  if (currentTab.value === TAB.PENDING_REQUESTS) {
    queryParams.status = constant.orderStatus.PENDING;
    return getOrgQuotationRequestCallable(queryParams);
  } else if (currentTab.value === TAB.ACCEPTED_LIST) {
    queryParams.status = constant.orderStatus.APPROVED;
    if (params.startDate && params.endDate) {
      queryParams.startDate = params.startDate;
      queryParams.endDate = params.endDate;
      return getOrgQuotationApprovedCallable(queryParams);
    } else {
      // 날짜 범위가 없으면 빈 결과를 반환 (Diagnosis.vue 참고)
      return { data: { Items: [], LastEvaluatedKey: null } };
    }
  }
};

const {
  paginatedItems: orders,
  listLoading,
  error,
  currentPage,
  hasNextPage,
  goToNextPage,
  goToPreviousPage,
  refreshData,
} = usePagination<
  Order,
  { status?: string; startDate?: string; endDate?: string; searchKey?: string; searchValue?: string }
>(
  getQuotations,
  10 // 페이지 크기
);

// 전역 로딩 상태를 포함하는 래퍼 함수들
async function wrappedRefreshOrders() {
  loading.value = true;
  const searchParams: { searchKey?: string; searchValue?: string } = {};

  if (searchValueForPending.value && searchValueForPending.value.trim() !== "") {
    searchParams.searchKey = searchTypeForPending.value;
    searchParams.searchValue = searchValueForPending.value.trim();
  }
  await refreshData(searchParams);
  loading.value = false;
}

async function wrappedGoToNextPage() {
  if (!hasNextPage.value) return;
  loading.value = true;
  await goToNextPage();
  loading.value = false;
}

async function wrappedGoToPreviousPage() {
  if (currentPage.value <= 1) return;
  loading.value = true;
  await goToPreviousPage();
  loading.value = false;
}

async function displayOrderDetails(order: Order) {
  selectedOrder.value = order;
  showOrderDetailsModal.value = true;
}

function closeOrderDetailsModal() {
  showOrderDetailsModal.value = false;
}

function onOrderDetailsModalClose() {
  selectedOrder.value = null; // 상세 정보 초기화
}

async function gotoOrderPage() {
  showActionDialog({
    title: "확인",
    content: "견적관리 화면으로 이동하시겠습니까?",
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      router.push({ name: USER_ROUTES.OrgOrder.Name });
    },
    onCancel: async () => {
      await wrappedRefreshOrders();
    },
  });
}

async function approveQuotation(quotationSK: string) {
  showActionDialog({
    title: "견적 요청 수락 및 견적서 생성",
    content: "이 견적 요청을 수락하고 견적서를 작성하시겠습니까?",
    positiveText: "확인",
    negativeText: "취소",
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      const payload: ChangeStatus = {
        SK: quotationSK,
        status: constant.orderStatus.APPROVED, // 수락 시 상태 변경
      };
      const result = await orgQuotationToOrderCallable(payload);
      if (common.evalFunctionResult(result)) {
        message.success("견적 요청이 성공적으로 수락되었습니다. 견적서가 생성됩니다.");
        await gotoOrderPage();
        if (showOrderDetailsModal.value) closeOrderDetailsModal();
      } else {
        message.error(common.getResultError(result) || "견적 요청 수락 중 오류가 발생했습니다.");
      }
    },
  });
}

async function cancelQuotation(orderSK: string) {
  showActionDialog({
    title: "견적 요청 거절",
    content: "이 견적 요청을 거절(삭제)하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
    positiveText: "거절",
    negativeText: "취소",
    positiveButtonProps: { type: "error" },
    confirmButtonLoadingText: "처리 중...",
    onConfirm: async () => {
      const result = await cancelQuotationCallable({ SK: orderSK }); // cancelQuotationCallable은 SK만 받을 수 있음
      if (common.evalFunctionResult(result)) {
        message.success("견적 요청이 성공적으로 거절(삭제)되었습니다.");
        await wrappedRefreshOrders();
        if (showOrderDetailsModal.value) closeOrderDetailsModal();
      } else {
        message.error(common.getResultError(result) || "견적 요청 거절 중 오류가 발생했습니다.");
      }
    },
  });
}

async function onFileDonwload(row: Order) {
  loading.value = true;
  await downloadQuotationFile(row.quotation_pdf, row.name);
  loading.value = false;
}

async function handleTabChange(tabName: string) {
  currentTab.value = tabName;
  orders.value = []; // 탭 변경 시 목록 초기화
  error.value = null;
  if (tabName === TAB.ACCEPTED_LIST) {
    showAcceptedResults.value = false;
    dateRangeForAccepted.value = null;
    // 수락된 목록은 날짜 선택 후 조회하므로 여기서는 자동 로드 안 함
  } else {
    // "수신한 요청" 탭으로 오면 바로 조회
    await wrappedRefreshOrders();
  }
}

async function fetchAcceptedOrdersByDateRange() {
  if (!isSearchEnabled.value) {
    message.error("조회 조건을 하나 이상 입력해주세요.");
    return;
  }

  const searchParams: { startDate?: string; endDate?: string; searchKey?: string; searchValue?: string } = {};

  if (dateRangeForAccepted.value) {
    const [startTimestamp, endTimestamp] = dateRangeForAccepted.value;
    searchParams.startDate = startTimestamp.toString();
    searchParams.endDate = common.addDaysToTimestamp(endTimestamp, 1).toString();
  }

  if (searchValueForAccepted.value && searchValueForAccepted.value.trim() !== "") {
    searchParams.searchKey = searchTypeForAccepted.value;
    searchParams.searchValue = searchValueForAccepted.value.trim();
  }

  showAcceptedResults.value = false;
  await refreshData(searchParams);
  showAcceptedResults.value = true;
}

onMounted(() => {
  if (currentTab.value === TAB.PENDING_REQUESTS) {
    wrappedRefreshOrders(); // "수신한 요청" 탭의 초기 데이터 로드
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NSpace), { vertical: "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                "item-style": "display: flex;",
                align: "center"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createElementVNode("div", { style: {"font-size":"20px","font-weight":"bold"} }, "견적 요청 관리", -1)
                ])),
                _: 1
              }),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
              _withDirectives(_createVNode(Loading, null, null, 512), [
                [_vShow, _unref(loading)]
              ]),
              _createVNode(_unref(NTabs), {
                type: "line",
                animated: "",
                value: currentTab.value,
                "onUpdate:value": [
                  _cache[5] || (_cache[5] = ($event: any) => ((currentTab).value = $event)),
                  handleTabChange
                ]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NTabPane), {
                    name: TAB.PENDING_REQUESTS,
                    disabled: _unref(listLoading)
                  }, {
                    tab: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        align: "center",
                        size: 8,
                        "wrap-item": false
                      }, {
                        default: _withCtx(() => [
                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "수신한 요청", -1)),
                          (_unref(listLoading) && currentTab.value === TAB.PENDING_REQUESTS)
                            ? (_openBlock(), _createBlock(_unref(NSpin), {
                                key: 0,
                                size: "small"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        vertical: "",
                        style: {"margin-top":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSpace), {
                            align: "baseline",
                            "item-style": "display: flex;"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NFormItem), {
                                label: "검색",
                                style: {"min-width":"350px"},
                                "label-placement": "left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NInputGroup), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NSelect), {
                                        value: searchTypeForPending.value,
                                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchTypeForPending).value = $event)),
                                        options: searchOptions,
                                        style: {"width":"120px"}
                                      }, null, 8, ["value"]),
                                      _createVNode(_unref(NInput), {
                                        value: searchValueForPending.value,
                                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchValueForPending).value = $event)),
                                        placeholder: "검색어를 입력하세요",
                                        clearable: ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(NFormItem), {
                                style: {"min-width":"300px"},
                                "label-placement": "left"
                              }),
                              _createVNode(_unref(NFormItem), { style: {"margin-bottom":"0"} }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NButton), {
                                    type: "primary",
                                    onClick: wrappedRefreshOrders
                                  }, {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createTextVNode(" 조회 ")
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_unref(listLoading) && currentTab.value === TAB.PENDING_REQUESTS)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 견적 요청 목록을 불러오는 중... "))
                        : (_unref(error) && currentTab.value === TAB.PENDING_REQUESTS)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(error)), 1))
                          : (currentTab.value === TAB.PENDING_REQUESTS)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  (_unref(orders).length > 0)
                                    ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                        key: 0,
                                        columns: activeColumns.value,
                                        data: _unref(orders),
                                        pagination: false,
                                        bordered: true
                                      }, null, 8, ["columns", "data"]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_7, "수신된 견적 요청이 없습니다."))
                                ]),
                                (_unref(orders).length > 0 && !_unref(listLoading) && !_unref(error))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                      _createVNode(_unref(NButton), {
                                        onClick: wrappedGoToPreviousPage,
                                        disabled: _unref(currentPage) === 1,
                                        style: {"margin-right":"8px"}
                                      }, {
                                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                                          _createTextVNode(" 이전 페이지 ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"]),
                                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                                      _createVNode(_unref(NButton), {
                                        onClick: wrappedGoToNextPage,
                                        disabled: !_unref(hasNextPage)
                                      }, {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                          _createTextVNode(" 다음 페이지 ")
                                        ])),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["name", "disabled"]),
                  _createVNode(_unref(NTabPane), {
                    name: TAB.ACCEPTED_LIST,
                    disabled: _unref(listLoading)
                  }, {
                    tab: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        align: "center",
                        size: 8,
                        "wrap-item": false
                      }, {
                        default: _withCtx(() => [
                          _cache[14] || (_cache[14] = _createElementVNode("span", null, "수락된 목록", -1)),
                          (_unref(listLoading) && currentTab.value === TAB.ACCEPTED_LIST)
                            ? (_openBlock(), _createBlock(_unref(NSpin), {
                                key: 0,
                                size: "small"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(NSpace), {
                        vertical: "",
                        style: {"margin-top":"10px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(NSpace), {
                            align: "center",
                            "item-style": "display: flex;"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NFormItem), {
                                label: "검색",
                                style: {"min-width":"350px"},
                                "label-placement": "left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NInputGroup), null, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(NSelect), {
                                        value: searchTypeForAccepted.value,
                                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchTypeForAccepted).value = $event)),
                                        options: searchOptions,
                                        style: {"width":"120px"}
                                      }, null, 8, ["value"]),
                                      _createVNode(_unref(NInput), {
                                        value: searchValueForAccepted.value,
                                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchValueForAccepted).value = $event)),
                                        placeholder: "검색어를 입력하세요",
                                        clearable: ""
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(NFormItem), {
                                label: "수락일 기간 선택",
                                style: {"min-width":"300px"},
                                "label-placement": "left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NDatePicker), {
                                    value: dateRangeForAccepted.value,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dateRangeForAccepted).value = $event)),
                                    type: "daterange",
                                    clearable: ""
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(NFormItem), {
                                style: {"margin-bottom":"0"},
                                "label-placement": "left"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(NButton), {
                                    type: "primary",
                                    onClick: fetchAcceptedOrdersByDateRange,
                                    disabled: !isSearchEnabled.value
                                  }, {
                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                      _createTextVNode(" 조회 ")
                                    ])),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (showAcceptedResults.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _withDirectives(_createVNode(Loading, null, null, 512), [
                              [_vShow, _unref(listLoading) && currentTab.value === TAB.ACCEPTED_LIST]
                            ]),
                            (!_unref(listLoading) && _unref(error) && currentTab.value === TAB.ACCEPTED_LIST)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(error)), 1))
                              : _createCommentVNode("", true),
                            (!_unref(listLoading) && !_unref(error) && _unref(orders).length > 0 && currentTab.value === TAB.ACCEPTED_LIST)
                              ? (_openBlock(), _createBlock(_unref(NDataTable), {
                                  key: 1,
                                  columns: activeColumns.value,
                                  data: _unref(orders),
                                  pagination: false,
                                  bordered: true,
                                  style: {"margin-top":"10px"}
                                }, null, 8, ["columns", "data"]))
                              : _createCommentVNode("", true),
                            (!_unref(listLoading) && !_unref(error) && _unref(orders).length === 0 && currentTab.value === TAB.ACCEPTED_LIST)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, " 선택된 기간에 해당하는 수락된 견적 요청이 없습니다. "))
                              : _createCommentVNode("", true),
                            (_unref(orders).length > 0 && !_unref(listLoading) && !_unref(error))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_unref(NButton), {
                                    onClick: wrappedGoToPreviousPage,
                                    disabled: _unref(currentPage) === 1,
                                    style: {"margin-right":"8px"}
                                  }, {
                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                      _createTextVNode(" 이전 페이지 ")
                                    ])),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(currentPage)) + " 페이지", 1),
                                  _createVNode(_unref(NButton), {
                                    onClick: wrappedGoToNextPage,
                                    disabled: !_unref(hasNextPage)
                                  }, {
                                    default: _withCtx(() => _cache[17] || (_cache[17] = [
                                      _createTextVNode(" 다음 페이지 ")
                                    ])),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, "조회할 기간을 선택해주세요."))
                    ]),
                    _: 1
                  }, 8, ["name", "disabled"])
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NModal), {
            show: showOrderDetailsModal.value,
            "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((showOrderDetailsModal).value = $event)),
            preset: "card",
            style: {"width":"800px"},
            title: "견적 상세 정보",
            onAfterLeave: onOrderDetailsModalClose
          }, {
            default: _withCtx(() => [
              (selectedOrder.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_unref(NDescriptions), {
                      "label-placement": "left",
                      bordered: "",
                      column: 2,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(NDescriptionsItem), { label: "기관명" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.name), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "수신자 이메일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.receiver_email), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당부서" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.dept || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "담당자" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.client.deptPersonName || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "총 금액",
                          span: "2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.totalPrice.toLocaleString()) + "원", 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(getQuotationStatusString)(selectedOrder.value.status)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), { label: "생성일" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(common.getYYYYMMDD2(new Date(Number(selectedOrder.value.createdDate)))), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(NDescriptionsItem), {
                          label: "결제 방법",
                          span: 2
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(selectedOrder.value.payment_method?.type === "bank_deposit"
                    ? "계좌이체"
                    : selectedOrder.value.payment_method?.type || "N/A"), 1)
                          ]),
                          _: 1
                        }),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 0,
                              label: "결제 계좌",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 1,
                              label: "입금자명",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.deposit_name), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (selectedOrder.value.payment_method?.type === 'bank_deposit')
                          ? (_openBlock(), _createBlock(_unref(NDescriptionsItem), {
                              key: 2,
                              label: "입금예정일",
                              span: 2
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(selectedOrder.value.payment_method.bank_date), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _cache[22] || (_cache[22] = _createElementVNode("h4", { style: {"margin-top":"20px","margin-bottom":"10px"} }, "견적 항목", -1)),
                    _createVNode(_unref(NDataTable), {
                      columns: orderItemColumns,
                      data: selectedOrder.value.products,
                      pagination: false,
                      bordered: true,
                      size: "small"
                    }, null, 8, ["data"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_unref(NButton), {
                        onClick: closeOrderDetailsModal,
                        type: "tertiary",
                        style: {"margin-right":"10px"}
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode(" 닫기 ")
                        ])),
                        _: 1
                      }),
                      (selectedOrder.value && selectedOrder.value.status === constant.orderStatus.PENDING)
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 0,
                            type: "primary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (approveQuotation(selectedOrder.value!.SK))),
                            style: {"margin-right":"10px"}
                          }, {
                            default: _withCtx(() => _cache[20] || (_cache[20] = [
                              _createTextVNode(" 수락 및 견적서 작성 ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (selectedOrder.value && selectedOrder.value.status === constant.orderStatus.PENDING)
                        ? (_openBlock(), _createBlock(_unref(NButton), {
                            key: 1,
                            type: "error",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (cancelQuotation(selectedOrder.value!.SK)))
                          }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode(" 견적 요청 거절 ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})